import React from 'react';
import { FormField, SearchField } from '@/components/custom/erp';
import { donViSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { DonViCoSo } from '@/types/schemas';

interface FilterTabProps {
  searchFieldStates: {
    unit: DonViCoSo | null;
    setUnit: (unit: DonViCoSo | null) => void;
  };
}

const FilterTab = ({ searchFieldStates }: FilterTabProps) => {
  return (
    <div className='p-4'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Đơn vị</Label>
        <SearchField<DonViCoSo>
          type='text'
          name='ma_unit'
          searchEndpoint={`/${QUERY_KEYS.DON_VI}/`}
          searchColumns={donViSearchColumns}
          columnDisplay='ma_unit'
          displayRelatedField='ten_unit'
          dialogTitle='Danh mục đơn vị'
          value={searchFieldStates.unit?.ma_unit}
          relatedFieldValue={searchFieldStates.unit?.ten_unit}
          onRowSelection={searchFieldStates.setUnit}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Trạng thái</Label>
        <FormField
          name='status'
          type='select'
          className='w-[200px]'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '0', label: 'Chưa ghi sổ' },
            { value: '3', label: 'Chờ duyệt' },
            { value: '5', label: 'Đã ghi sổ' }
          ]}
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Lọc theo người SD</Label>
        <FormField
          name='user_id0'
          type='select'
          className='w-[200px]'
          options={[
            { value: 'ALL', label: 'Tất cả' },
            { value: '1', label: 'Lọc theo người tạo' }
          ]}
        />
      </div>
    </div>
  );
};

export default FilterTab;
